import { makeStyles } from 'tss-react/mui';

type TStyleParams = {
  lines: number;
  maxWidth?: number | string;
};

export const useTruncatedTextStyles = makeStyles<TStyleParams>()((_theme, { lines, maxWidth }) => ({
  text: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    // lets long unbroken values (e.g. emails) wrap instead of stretching the layout
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    minWidth: 0,
    maxWidth: maxWidth ?? '100%',
  },
  tooltipContent: {
    display: 'block',
    // keeps original line breaks/spacing of multi-line values
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));
